var React = require('react');

function ArrowScroll (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .scroll-stroke {\n        fill:none;\n        stroke: #000;\n        stroke-width: 1;\n      }\n    ")),React.createElement("g",{"id":"arrow-scroll","transform":"translate(0.354 0.354)","key":1},React.createElement("path",{"className":"scroll-stroke","d":"M11243.572,10281.677l8.1,8.1-8.1,8.1","transform":"translate(10297.872 -11243.572) rotate(90)"}))]);
}

ArrowScroll.defaultProps = {"width":"16.902","height":"9.158","viewBox":"0 0 16.902 9.158"};

module.exports = ArrowScroll;

ArrowScroll.default = ArrowScroll;
